import { Flex as AntdFlex, FlexProps as AntdFlexProps } from "antd";
import { CMP_PREFIX } from "@/base/constant";

export interface FlexProps extends AntdFlexProps {}

export const flexPrefixCls = `${CMP_PREFIX}-flex`;

export const Flex = ({ ...props }: FlexProps) => {
  return <AntdFlex {...props} />;
};
